/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import React, {useEffect, useState} from 'react';
import {ReactComponent as Close} from "../assets/img/forms/modal-close.svg";
import LoginForm from "../views/account/LoginForm";
import {useTranslation} from "react-i18next";

const LoginModal = (props) => {

    const { t, i18n } = useTranslation();

    const [openModal, setOpenModal] = useState(props.showModal);
    const [onComplete, setOnComplete] = useState(null);

    function openLoginModal(){
        setOpenModal(true);
    }
    function closeLoginModal(){
        setOpenModal(false);
    }

    useEffect( () =>{
        if(onComplete){
            //setOpenModal(false);
            // auto den prolavainei na trexei giati stin carPage exo to LoginModal mesa sto if tou user.profile.isLogged opote me to poy ginetai to logedin to modal feugei
            // gi auto kai to modal kleinei xoris to setOpenModal(false);
        }
    }, [onComplete] )

    return (
        <>
            {props.showButton ? (
                <button className='btn-request btn btn-primary btn-icon btn-icon-left' onClick={openLoginModal}>
                    {props.buttonText}
                </button>
            ) : (
                ''
            )}
            <div className={`modal loginModal fade ${openModal ? "show" : ""}`} style={ openModal ? { display: 'block'} : {}} tabIndex="-1" role="dialog" aria-labelledby="requestModalTitle" aria-hidden="true" onClick={ closeLoginModal }>
                <div className="modal-dialog modal-dialog-centered modal-md" role="document" onClick={ (e) => e.stopPropagation() }>
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <button type="button" className="close" aria-label="Close" onClick={closeLoginModal}>
                                <span aria-hidden="true"><Close/></span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <div className='big--title mb-5'>{ t('parts.LoginToYourAccount' ) }</div>
                            <LoginForm onComplete={setOnComplete} />

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

LoginModal.defaultProps = {
    showButton: true
};

export default LoginModal;